import React from 'react';
import PropTypes from 'prop-types';
import { modal } from 'react-redux-modal';
import Cookie from 'js-cookie';
import TrackedButton from '../../Buttons/TrackedButton';

class PopoutVideoManager extends React.Component {

  constructor(props) {
    super(props);
    this.popout = this.popout.bind(this);
  }

  popout() {
    modal.clear();

    if (this.props.setCookie) {
      Cookie.set('showed_pop_livecam', 1);
    }
    const newWindow = window.open(`/livecams/player/${this.props.group}/${this.props.slug}`,
      `${this.props.slug}-player`,
      'status=0,toolbar=0,directories=0,menubar=0,resizable=0,scrollbars=0,width=942px,height=530px',
    );
    if (window.focus) newWindow.focus();
  }

  render() {
    return (
      <div className="pop-out-btn">
        <TrackedButton
          className="video-player-btn text-btn inverse-btn text-uppercase popoff-button d-none d-lg-block"
          onClick={this.popout}
          title="Pop Livecam"
          action={`Popped livecam for  ${this.props.title}`}
        />
      </div>
    );
  }
}

PopoutVideoManager.propTypes = {
  slug: PropTypes.string,
  group: PropTypes.string,
  setCookie: PropTypes.bool,
};

PopoutVideoManager.defaultProps = {
  slug: '',
  group: '',
  setCookie: false,
};

export default PopoutVideoManager;
